<template>

  <b-row>
    <b-col md="12">
      <b-card
        no-body
        :class="{ open: visibleBody }"
      >
        <b-card-header
          :class="{ collapsed: !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="() => visibleBody = !visibleBody"
          style="padding: 1rem; background-color: #0080C9; color: white; font:45px; padding:15px; border-color: rgb(81 174 226)"
        >
          <span class="lead collapse-title">
            <strong>RECETA</strong>
          </span>

          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 1.5rem">

            <!-- <RecetaList/> -->

            <RecetaFormulario/>

            <RecetaTable />

            <!-- <b-row 
              class="mt-3" 
              v-if="stMedicamentosList.length > 0"
            >
              <b-col class="text-right">
               
                <b-button 
                  variant="danger"  
                  @click="resetReceta"
                >
                  Resetear Recetas
                </b-button>
              </b-col>
            </b-row> -->

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import RecetaFormulario from "./RecetaFormulario.vue";
import RecetaTable      from "./RecetaTable.vue";

export default {
  name: "Receta",

  components: {
    RecetaFormulario,
    RecetaTable
  },

  data() {
    return {
      visibleBody: false,
    };
  },

  methods: {
    resetReceta() {
      this.$swal({
        title: "¿Estás seguro?",
        text: "Esta acción no se puede deshacer y eliminará todas los medicamentos recetados guardados.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, resetear",
        cancelButtonText: "No, cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.removeItem("atencionReceta");

          this.$store.commit("setMedicamentosList", []);

          this.$swal({
            title: "Reset Completo",
            text: "La receta ha sido reseteadas.",
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
          });
        }
      });
    },
  },

  computed: {
    ...mapState({
      stMedicamentosList: state => state.atencionCita.receta.medicamentosList,
    }),
  },


}
</script>
